import { useLanguage } from '@/contexts/LanguageContext';
import { Input } from '@/components/ui/input';
import { Building2, User, Mail, Phone } from 'lucide-react';

export function StepBasisdaten({ form, setForm }) {
  const { t } = useLanguage();
  const update = (key, val) => setForm(prev => ({ ...prev, [key]: val }));

  return (
    <div className="space-y-5" data-testid="step-basisdaten">
      <div className="text-center mb-6">
        <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-3">
          <Building2 className="h-6 w-6 text-primary" />
        </div>
        <h3 className="font-serif text-xl font-bold text-foreground">{t('dlWizard.step1Title')}</h3>
        <p className="text-sm text-muted-foreground mt-1">{t('dlWizard.step1Desc')}</p>
      </div>

      <div>
        <label className="text-sm font-medium text-foreground mb-1.5 block">{t('dlWizard.firmaLabel')} *</label>
        <div className="relative">
          <Building2 className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            value={form.firma}
            onChange={(e) => update('firma', e.target.value)}
            placeholder="z.B. Forstbetrieb Müller GmbH"
            className="pl-10"
            data-testid="input-firma"
          />
        </div>
      </div>

      <div className="grid sm:grid-cols-2 gap-4">
        <div>
          <label className="text-sm font-medium text-foreground mb-1.5 block">{t('dlWizard.kontaktLabel')} *</label>
          <div className="relative">
            <User className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <Input
              value={form.kontakt_name}
              onChange={(e) => update('kontakt_name', e.target.value)}
              placeholder="Max Müller"
              className="pl-10"
              data-testid="input-name"
            />
          </div>
        </div>
        <div>
          <label className="text-sm font-medium text-foreground mb-1.5 block">{t('dlWizard.emailLabel')} *</label>
          <div className="relative">
            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <Input
              type="email"
              value={form.kontakt_email}
              onChange={(e) => update('kontakt_email', e.target.value)}
              placeholder="info@forstbetrieb.de"
              className="pl-10"
              data-testid="input-email"
            />
          </div>
        </div>
      </div>

      <div>
        <label className="text-sm font-medium text-foreground mb-1.5 block">{t('dlWizard.telefonLabel')}</label>
        <div className="relative">
          <Phone className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            value={form.kontakt_telefon}
            onChange={(e) => update('kontakt_telefon', e.target.value)}
            placeholder="+49 170 1234567"
            className="pl-10"
            data-testid="input-telefon"
          />
        </div>
      </div>
    </div>
  );
}
